"use client"

import axios from "axios";



//const defaultBaseUrl = "http://localhost:8081/wp-json/wp/v2/";
const defaultBaseUrl = "https://cms.londamilano.com/wp-json/wp/v2/";
const version = "0.0.1";

const API = axios.create({
    baseURL: process.env?.BASE_API_URL ?? defaultBaseUrl,
    responseType: "json",
    timeout: 20000,
    headers: {
        "Content-Type": "application/json",
        "X-Accept-Version": version,
    },
});



API.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error.response) {
            let status = 0;
            let message = "";
            if (error.response.data != null) {
                status = error.response.data.code || 0;
                message = error.response.data.message || "";
                if (error.response.data.validation != null) {
                    message = error.response.data.validation[0];
                }
            }

            return Promise.reject({ code: status, message: message });
        } else if (error.request) {
            // Handle request errors
        } else if (error.message) {
            return Promise.reject({ code: 0, message: "Request Canceled" });
        }
    }
);

export default API;

export function sendMedia(url, response, uri) {
    const formData = new FormData();
    formData.append("Acl", response.acl);
    formData.append("Content-Type", response["content-type"]);
    formData.append("Key", response.key);
    formData.append("X-Amz-Credential", response["X-Amz-Credential"]);
    formData.append("X-Amz-Algorithm", response["X-Amz-Algorithm"]);
    formData.append("X-Amz-Date", response["X-Amz-Date"]);
    formData.append("Policy", response.Policy);
    formData.append("X-Amz-Signature", response["X-Amz-Signature"]);
    formData.append("file", uri);

    return axios.post(url, formData);
}

export const postElement = (endpoint, data = {}, signal = false) => API.post(endpoint, data ? data : {}, signal && {signal: signal});
export const getElement = (endpoint, signal = false) => API.get(endpoint, signal && {signal: signal});
export const getElementParams = (endpoint, params = false, signal = false) => API.get(endpoint + ( params ? serialize(params) : ''), signal && {signal: signal});



export function serialize(data) {
    if (typeof data != "object") {
        return "?" + data;
    }
    var str = [];
    for (var p in data) {
        if (data[p] && data.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
        }
    }
    return "?" + str.join("&");
}